/**
 * !!! NE PAS EDITER !!!
 * Editer les fichier configuration.*.json
 */

import dev  from './configuration.dev.json'
import prod from './configuration.prod.json'

let config = process.env.NODE_ENV === 'production' ? prod : dev

export default config
